import { render } from "./Modulo.vue?vue&type=template&id=ed605680"
import script from "./Modulo.vue?vue&type=script&lang=js"
export * from "./Modulo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__